import { replace } from 'ramda'

/**
 * Parses a string from camel case by adding spaces before capital letters.
 * This is a simple utility that can be used in combination with other text transformers.
 *
 * @param {string} input - The camelCase string to parse.
 * @returns {string} The parsed string with spaces before capital letters.
 */
export const parseFromCamelCase = replace(/([a-z0-9])([A-Z])/g, '$1 $2')
